module.exports = __webpack_public_path__ + "static/media/cross-dark.d2d52840.svg";